import { ColoursObj } from '@eventr/common-storybook'
import ApartmentIcon from '@mui/icons-material/Apartment'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import { Chip } from '@mui/material'
interface PaymentTypeProps {
    paymentType: string
}
export const PaymentType = ({ paymentType }: PaymentTypeProps) => {
    if (paymentType === 'prepay') {
        return (
            <Chip
                style={{
                    borderRadius: '4px',
                    backgroundColor: ColoursObj.states.warningLight,
                    color: ColoursObj.shades.shade1,
                }}
                label="Pay Now"
                icon={<CreditCardIcon htmlColor={ColoursObj.shades.shade2} />}
            />
        )
    }
    if (paymentType === 'payAtHotel') {
        return (
            <Chip
                style={{
                    borderRadius: '4px',
                    backgroundColor: ColoursObj.states.successLight,
                    color: ColoursObj.shades.shade1,
                }}
                label="Pay at Hotel"
                icon={<ApartmentIcon htmlColor={ColoursObj.shades.shade2} />}
            />
        )
    }
    return null
}
